import React from 'react';

interface SectionHeaderProps {
    index: string;
    eyebrow: string;
    title: string;
    description: string;
    year?: number;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
    index,
    eyebrow,
    title,
    description,
    year,
}) => (
    <header className="section-heading">
        <div className="section-index" aria-hidden="true">
            {index}
        </div>
        <div>
            <p className="eyebrow">
                {eyebrow}
                {year ? <span> · {year}</span> : null}
            </p>
            <h2>{title}</h2>
            <p className="section-description">{description}</p>
        </div>
    </header>
);

export default React.memo(SectionHeader);
